import React, { useContext } from 'react';
import Axios from 'axios';
import Pokemon from './Pokemon.js';
import { Context } from '../App.js';

class PokemonTeam extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
            teamlist: null,
            valid: false
        };
    }

    componentDidMount() {

        Axios.get('https://pokemon-app-server.azurewebsites.net/pokemon/' + this.props.team)
        .then( (res) => {
            if (Array.isArray(res.data.pokemon)) {
                this.setState({teamlist: res.data.pokemon});
                this.setState({valid: true});
            }
            else {
                this.setState({valid: false});
            }

            if (this.props.onChange) {
                this.props.onChange(this.state);
            }
        })
        .catch( error => this.setState({valid: false}))
    }

    number = event => {
        this.setState({team: Math.min(9, Math.max(1, event.target.value))});

        Axios.get('https://pokemon-app-server.azurewebsites.net/pokemon/' + event.target.value)
        .then( (res) => {
            if (Array.isArray(res.data.pokemon)) {
                this.setState({teamlist: res.data.pokemon});
                this.setState({valid: true});
            }
            else {
                this.setState({valid: false});
            }

            if (this.props.onChange) {
                this.props.onChange(this.state);
            }
        })
        .catch( error => this.setState({valid: false}))
    }

    refresh = () => {
        Axios.get('https://pokemon-app-server.azurewebsites.net/pokemon/' + this.props.team)
        .then( (res) => {
            if (Array.isArray(res.data.pokemon)) {
                this.setState({teamlist: res.data.pokemon});
                this.setState({valid: true});
            }
            else {
                this.setState({valid: false});
            }

            if (this.props.onChange) {
                this.props.onChange(this.state);
            }
        })
        .catch( error => this.setState({valid: false}))
    }

    render() {
        //This should find your team from the MongoDB database and display them all.
        return( 
            <div>
                <h2>Your Team</h2> 
                <button onClick={this.refresh}>Refresh</button>

                { this.state.valid ? 
                
                this.state.teamlist.map((mon) => {
                    return <Pokemon pokemon={mon} key={mon._id}/>;
                })

                : <p>There are no Pokémon on this team!</p> }

            </div> 
        );
    }
}

export default PokemonTeam;